import React from 'react';
import { AnimatePresence } from 'framer-motion';
import Toast from './Toast';
import { useToast } from './useToast';

export const ToastContext = React.createContext<ReturnType<typeof useToast> | null>(
  null
);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const toast = useToast();

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div className="fixed bottom-0 right-0 z-50 p-4">
        <AnimatePresence>
          {toast.toasts.map((t) => (
            <Toast
              key={t.id}
              id={t.id}
              type={t.type}
              header={t.header}
              body={t.body}
              duration={t.duration}
              onDismiss={toast.removeToast}
            />
          ))}
        </AnimatePresence>
      </div>
    </ToastContext.Provider>
  );
};

export const useToastContext = () => {
  const context = React.useContext(ToastContext);
  if (!context) {
    throw new Error('useToastContext must be used within a ToastProvider');
  }
  return context;
}; 